import React from 'react';
import { IconProps, IconWrap } from './IconWrap';

export function IconCross({ color = '#3A4B68', width = 10, height = 9, ...props }: IconProps) {
    return (
        <IconWrap {...props} width={width} height={height} viewBox="0 0 10 9" iconClass="cross">
            <path
                d="M5.74841 4.51246L8.86367 1.3972C9.06305 1.19782 9.06305 0.84891 8.86367 0.649533C8.66429 0.450156 8.31538 0.450156 8.11601 0.649533L5.00074 3.7648L1.88548 0.649533C1.6861 0.450156 1.33719 0.450156 1.13781 0.649533C0.938437 0.84891 0.938437 1.19782 1.13781 1.3972L4.25308 4.51246L1.13781 7.6028C0.938437 7.80218 0.938437 8.15109 1.13781 8.35047C1.2375 8.45016 1.38704 8.5 1.51165 8.5C1.63626 8.5 1.78579 8.45016 1.88548 8.35047L5.00074 5.2352L8.11601 8.35047C8.2157 8.45016 8.36523 8.5 8.48984 8.5C8.61445 8.5 8.76398 8.45016 8.86367 8.35047C9.06305 8.15109 9.06305 7.80218 8.86367 7.6028L5.74841 4.51246Z"
                fill={color}
            />
        </IconWrap>
    );
}
